import CarotekColors from "@carotek/utils/Colors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

export interface ProductListTopColoumnStyles {
    container?: InjectableCss;
    leftGridItem?: InjectableCss;
    rightGridItem?: InjectableCss;
}

export const controlsContainerStyles: ProductListTopColoumnStyles = {
    container: {
        css: css`
            display: flex;
            align-items: center;
            border: 1px solid ${CarotekColors.grey12};
            margin-bottom: 10px;
            padding: 0.75em 1em;
            [data-test-selector="productList_pagination"] > span {
                display: none;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    flex-wrap: wrap;
                    padding: 12px 8px 8px 8px;
                `,
                css`
                    flex-wrap: wrap;
                    padding: 12px 8px 8px 8px;
                `,
                css`
                    flex-wrap: wrap;
                `,
                css`
                    flex-wrap: wrap;
                     [data-test-selector="productList_pagination"]{
                         justify-content: center; 
                     }
                `,
                null,
            ])}
        `,
    },
    leftGridItem: {
        css: css`
            flex-grow: 2;
            [class^="Wrapper"] {
                width: auto;
                display: flex;
            }
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                css`
                    > div {
                        justify-content: center; 
                    }
                `,
                null,
            ])}
        `,
    },
    rightGridItem: {
        css: css`
            flex-grow: 1;
            align-self: flex-end;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
        `,
    },
};

const styles = controlsContainerStyles;

const ProductListTopColoumn: FC<Props> = ({ id, view }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.leftGridItem}>
                <Zone contentId={id} zoneName="Content00" />
            </StyledWrapper>
            <StyledWrapper {...styles.rightGridItem}>
                <Zone contentId={id} zoneName="Content01" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListTopColoumn),
    definition: {
        group: "Product List",
        displayName: "Product List Top Coloumn",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
